<template>
  <div class="w-full flex flex-col md:flex-row">
    <nav
      class="sm:left-0 sm:block sm:fixed sm:top-0 sm:bottom-0 md:left-0 md:block md:relative md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-80 sm:w-full z-10 py-4 px-6"
    >
      <div
        class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
      >
        <!-- Toggler -->
        <button
          class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
          type="button"
          v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
        >
          <i class="fa fa-bars"></i>
        </button>
        <!-- Brand -->
        <h6
          class="md:min-w-full text-blueGray-500 text-sm uppercase block pt-1 pb-4 no-underline"
        >
          {{ dashboard_data?.last_name }}, {{ dashboard_data?.first_name }}
        </h6>

        <div
          class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-2 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
          v-bind:class="collapseShow"
        >
          <!-- Collapse header -->
          <div
            class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
          >
            <div class="flex flex-wrap">
              <div class="w-6/12">
                <h6
                  class="md:min-w-full text-blueGray-500 text-base uppercase font-bold block pt-1 pb-4 no-underline"
                >
                  {{ dashboard_data?.last_name }}, {{ dashboard_data?.first_name }}
                </h6>
              </div>
              <div class="w-6/12 flex justify-end">
                <button
                  type="button"
                  class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                  v-on:click="toggleCollapseShow('hidden')"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
          <button
            type="button"
            @click="redirect('create-authorization')"
            class="group relative w-full flex justify-center py-2 px-2 border border-transparent text-sm font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
            aria-required="true"
          >
            <i class="fa fa-check-circle-o mr-1 mt-1" aria-hidden="true"></i>
            <span> Request an Authorization</span
            ><!--v-if-->
          </button>
          <button
            type="button"
            @click="redirect('claims')"
            class="pl-4 mt-2 group relative w-full flex justify-left py-2 px-4 border border-transparent text-sm font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
            aria-required="true"
          >
            <i class="fa fa-usd mr-1" aria-hidden="true"></i>
            <span> File a Claim</span
            ><!--v-if-->
          </button>
          <p class="mt-3 text-sm">
            <span class="text-gray-500 font-bold">Primary Address:</span><br />
            {{ dashboard_data?.addresses?.address1 }}
            {{ dashboard_data?.addresses?.address2 }} ,<br />
            {{ dashboard_data?.addresses?.city }} -
            {{ dashboard_data?.addresses?.zip }},<br />
            {{ dashboard_data?.addresses?.county }},
            {{ dashboard_data?.addresses?.state }}<br />
            <span
              @click="editDetails(true, 'primary')"
              class="mt-1 mb-3 cursor-pointer border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium"
              ><u>Update Address</u></span
            >
          </p>
          <hr>
          <p class="mt-3 text-sm">
            <span class="text-gray-500 font-bold">Coverages:</span><br />
           <ul class="list-disc ml-4">
              <li class="break-words" v-for="(item, i) in dashboard_data?.coverages" :key="i">
                
              <span>{{ item.coverage_id }} ({{item.planclass}})</span><br v-if="item.sub_coverage"> <span class="text-xs text-gray-600" v-if="item.sub_coverage">({{item.sub_coverage}})</span><br />
              </li>
            </ul>
            <span
              @click="editDetails(true, 'coverage')"
              class="mt-1 mb-3 cursor-pointer border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium"
              ><u>Update Coverages</u></span
            >
          </p>
          <hr>
          <p class="mt-3 text-sm">
            <span class="text-gray-500 font-bold">Practice Areas:</span><br />
            <span v-for="(item, i) in dashboard_data?.practice_states" :key="i">
              {{ item.county }}, {{ item.state_code }} ({{item.plan_class}}),<br />
            </span>
            <span
              @click="editDetails(true, 'coverage')"
              class="mt-1 cursor-pointer border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium"
              ><u>Update Practice Area</u></span
            >
          </p>
        </div>
      </div>
    </nav>
    <div class="px-3 mx-auto md:w-3/4 mt-1 xl:w-full w-full">

    <div>
      <dl class="mt-5 grid md:grid-cols-2 sm:grid-cols-1 gap-5 xl:grid-cols-4">
        <div class="px-4 py-5 bg-white shadow-custom rounded-lg overflow-hidden sm:p-6 border border-[#d9f9f9]">
          <dt class="text-sm font-medium text-gray-500 truncate">
          Open Cases Assigned
          </dt>
          <dd class="mt-1 text-2xl font-semibold cobalt-text-color">
            {{ dashboard_data?.total_cases }}
          </dd>
        </div>

        <div class="px-4 py-5 bg-white shadow-custom rounded-lg overflow-hidden sm:p-6 border border-[#d9f9f9]">
          <dt class="text-sm font-medium text-gray-500 truncate">
            Authorizations Pending
          </dt>
          <dd class="mt-1 text-2xl font-semibold cobalt-text-color">
            {{ dashboard_data?.total_open_authorization_request }}
          </dd>
        </div>

        <div class="px-4 py-5 bg-white shadow-custom rounded-lg overflow-hidden sm:p-6 border border-[#d9f9f9]">
          <dt class="text-sm font-medium text-gray-500 truncate">
            Claims - OPEN
          </dt>
          <dd class="mt-1 text-2xl font-semibold cobalt-text-color">
            {{ dashboard_data.total_open_claims }}
          </dd>
        </div>

        <div class="px-4 py-5 bg-white shadow-custom rounded-lg overflow-hidden sm:p-6 border border-[#d9f9f9]">
          <dt class="text-sm font-medium text-gray-500 truncate">
            Insurance Expiration
          </dt>
          <dd class="mt-1 text-xl font-semibold cobalt-text-color">
            {{ setDateFormat(dashboard_data?.lic_license_expire_date) }}
            <div v-if="dashboard_data?.days_of_expire_lic>0" class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0">
              {{dashboard_data?.days_of_expire_lic}} Days
            </div>
            <div v-if="dashboard_data?.days_of_expire_lic<=0" class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0">
              {{dashboard_data?.days_of_expire_lic}} Days Overdue
            </div>
          </dd>
        </div>
      </dl>
    </div>
    <div class="rounded-md bg-[#d9f9f9] p-4 m-2" v-if="is_inactive_member">
    <div class="flex">
      <div class="ml-3">
        <h3 class="text-sm font-medium text-[#1f3341]">Attention needed</h3>
        <div class="mt-2 text-sm text-[#1f3341]">
          <p>Please be aware that there are assigned cases where <b>member status of inactive or terminated</b> may affect coverage on case. Please submit an authorization request if you are presently working with the member(s) on their case so that we can confirm coverage.</p>
        </div>
      </div>
    </div>
  </div>
   <div class="mt-4 w-full">
        <div class="w-full">
          <div class="w-full  mb-12 xl:mb-0 px-2 sm:w-full">
            <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
              <div class="rounded-t mb-0 py-3 border-0">
                <div class="flex flex-wrap items-center">
                  <div class="relative w-full px-2 max-w-full flex-grow flex-1">
                    <h3
                      class="font-normal text-blueGray-700 text-base"
                    >
                      <i class="fa fa-female" aria-hidden="true"></i>
                      <i class="fa fa-male" aria-hidden="true"></i>
                      Cases/Members Currently Assigned to You
                    </h3>
                  </div>
                </div>
              </div>
              <div
                class="block w-full shadow-lg rounded border-2 bg-white"
              >
              <case-list :data="dashboard_data?.cases_assigned"></case-list>
              </div>
              <router-link
                v-if="dashboard_data?.cases_assigned?.length > 0"
                to="/cases"
                class="border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium mt-2"
                ><u>View More Cases</u></router-link
              >
            </div>
          </div>
        </div>
        <div class="w-full">
          <div class="w-full  mb-12 xl:mb-0 px-2 sm:w-full">
            <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
              <div class="rounded-t mb-0 py-3 border-0">
                <div class="flex flex-wrap items-center">
                  <div class="relative w-full px-2 max-w-full flex-grow flex-1">
                    <h3
                      class="font-normal text-blueGray-700 text-base"
                    >
                      <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                      Authorization Requests
                    </h3>
                  </div>
                </div>
              </div>
              <div
                class="block w-full shadow-lg rounded border-2 bg-white"
              >
             <auth-list :data="dashboard_data?.auth_request_assigned"></auth-list>
              </div>
              <router-link
                v-if="dashboard_data?.auth_request_assigned?.length > 0"
                to="/authorizations"
                class="border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium mt-2"
                ><u>View Auth Requests</u></router-link
              >
            </div>
          </div>
        </div>
      </div>
      
      <div class=" w-full">
        <div class="w-full">
          <div class="w-full  mb-12 xl:mb-0 px-2 sm:w-full">
            <div class="relative flex flex-col min-w-0 break-words w-full mb-6">
              <div class="rounded-t mb-0 py-3 border-0">
                <div class="flex flex-wrap items-center">
                  <div class="relative w-full px-2 max-w-full flex-grow flex-1">
                    <h3
                      class="font-normal text-blueGray-700 text-base"
                    >
                      <i class="fa fa-usd" aria-hidden="true"></i>
                      Recently Submitted Claims
                    </h3>
                  </div>
                </div>
              </div>
              <div
                class="block w-full shadow-lg rounded border-2 bg-white"
              >
             <claim-list :data="dashboard_data?.claim_assigned"></claim-list>
              </div>
              <router-link
                v-if="dashboard_data?.claim_assigned?.length > 0"
                to="/claims"
                class="border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-sm font-medium mt-2"
                ><u>View More Claims</u></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="edit_detail" class="hidden edit-profile">
      <div
        tabindex="0"
        class="z-40 left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-1 mx-auto my-0 max-w-full w-5/6">
          <div class="bg-white px-4 mt-2 pt-5 pb-4 sm:p-4 sm:pb-1 rounded-lg">
            <div
              class="flex flex-row justify-between p-1 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
              <p class="font-semibold text-gray-800 p-1">Edit Details</p>
              <i
                class="fa fa-close w-6 h-6 cursor-pointer"
                @click="editDetails(false)"
              ></i>
            </div>
            <div class="flex flex-col">
              <app-primary class="editprofile-popup-scroll"
                v-show="edit_page == 'primary'"
                ref="child_comp_0"
                :forms="form"
              ></app-primary>
              <app-coverages class="editprofile-popup-scroll"
                v-show="edit_page == 'coverage'"
                ref="child_comp_1"
                :forms="form"
              ></app-coverages>
              <button
                type="button"
                @click="updateAttorney()"
                class="self-end w-1/6 mb-2 mr-5 mt-6 rounded-md group relative flex justify-center py-3 px-3 border border-transparent text-md font-medium text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                aria-required="true"
              >
                <i
                  class="fa fa-pencil-square-o mr-1 mt-1"
                  aria-hidden="true"
                ></i>
                <span>Update</span>
              </button>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
      <div id="insuranceModal" class="hidden">
      <div
        tabindex="0"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
      >
        <div class="z-50 relative p-3 mx-auto my-0 max-w-full xl:w-2/5 md:w-full">
          <div class="bg-white px-4 mt-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
            <div
              class="flex flex-row justify-between p-2 bg-white border-b border-gray-200 rounded-tl-lg rounded-tr-lg"
            >
             <span class="text-red-500"><i class="fa fa-info-circle mr-2" aria-hidden="true"></i>Professional Liability Insurance</span>
              <i
                class="fa fa-close w-6 h-6 cursor-pointer"
                @click="remindInsuranceExpiration(false)"
              ></i>
            </div>
            <div class="flex flex-col px-6 py-5 bg-gray-50 fee-popup-scroll">
            <span v-if="dashboard_data.latest_lic_exp_date=='' || dashboard_data.latest_lic_exp_date==null">
              We do not have current professional liability insurance information for you. Please update your information and upload a copy of your declarations page. Thank you.
            </span>
            <span v-if="dashboard_data.latest_lic_exp_date!='' && dashboard_data.latest_lic_exp_date!=null">
              Your professional liability insurance information has expired. Please update your information and upload a copy of your declarations page. Thank you.
            </span>
            <div>
               <router-link
                to="/update-profile/practice"
                class="border-transparent cobalt-text-color hover:border-blue-300 hover:text-blue-700 inline-flex items-center text-md font-medium mt-2"
                ><u> Click here to update...</u></router-link
              >
            </div> 
            <span></span>
            </div>
          </div>
        </div>
        <div
          class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
        ></div>
      </div>
    </div>
    <div v-if="showPopup" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h1 class="text-center text-2xl font-semibold mb-4" style="color: #1f3341;">
          2025 Fee for Services Network Attorney Agreement
        </h1>
        <p class="text-gray-800 font-bold">
          We’re excited to share that U.S. Legal Services has updated and enhanced our Attorney Fee Reimbursement Schedule—designed with you in mind to offer greater overall compensation for the valuable work you do.<br />
          <br />
          The new schedule goes into effect on June 9, 2025. Please note that any matters authorized before that date will be paid based on the prior fee schedule, while all matters assigned and authorized on or after June 9 will follow the updated rates outlined in the below link.<br />
          <br />
          Please click the following link to review and sign the new Fee for Services Network Attorney Agreement and Fee Schedule:
          <a  href="#"
          @click.prevent="handleFeeAgreementClick"
          class="text-blue-500 hover:underline">Click here</a>
        </p>
        <button @click="dismissPopup" class="mx-auto px-4 py-2 bg-[#1f3341] text-white rounded-lg hover:bg-[#1f3341] block">Close</button>
       </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import AppCoverages from "./Profile/AppCoverages.vue";
import AppPrimary from "./Profile/AppPrimary.vue";
import AuthList from "./Authorization/CurrentAuths.vue";
import ClaimList from "./Claim/CurrentClaims.vue";
import CaseList from "./Case/CurrentCases.vue";
import $ from "jquery";
import Constants from "../constants.ts"; // importing constant resubale variables.
import { checkFeeAgreementStatus, generateDynamicLink } from '@/utils/feeAgreementPopup';
export default {
  components: { AppCoverages, AppPrimary,AuthList,ClaimList,CaseList},
  name: "Home",
  data() {
    return {
      dynamicLink: '',
      is_inactive_member:false,
      showPopup: false,
      edit_page: "",
      prevRoute :null,
      setDateFormat:Constants.setDateFormat,
      collapseShow: "hidden",
      form: {
        stateCount: { CA: 0, Others: 0 },
        lead: {},
        referral_cont_fee: false,
      },
    };
  },
  // computed: mapState(["dashboard_data"]),
  computed: {
    ...mapState(["dashboard_data"]),
    attid() {
      return this.$store._state.data.att_user.data.id;
    },
  },
  created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value!=null) {
          if(value.message=='Authorization failed'){
             this.$toast.error("Authorization Token Expired, Please login again!");
             this.$store.dispatch("logout");
              setTimeout(() => {
              this.$router.push({name:'Login'});
            }, 500);
          }
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.is_attorney_updated,
      (value) => {
        if (value == true) {
          this.$toast.success("Attorney updated successfully");
          if (this.edit_page == "coverage") {
            this.$store.dispatch("getCoverages", this.form.attorney_type);
          }
          this.editDetails(false);
          this.$store.dispatch("resetUpdateAttorneyFlag");
          this.$store.dispatch("getAttProfileData");
          this.$store.dispatch("getDashboardData");
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.dashboard_data,
      (value) => {
        if (value != null) {
          this.dashboard_data?.cases_assigned.forEach(element => {
            console.log(element)
            if((element.member_status=='Inactive' || element.member_status=='Terminated') && (element.status=='Assigned To Attorney' || element.status=='Assigned to Attorney' || element.status=='Authorized' || element.status=='Pending Confirmation')){
              //is_inactive_member
              this.is_inactive_member=true;
            }
          });
          this.dashboard_data.total_cases =
            parseInt(this.dashboard_data.total_matter_case_assigned) +
            parseInt(this.dashboard_data.total_cdl_case_assigned);
          this.dashboard_data.total_open_claims =
            parseInt(this.dashboard_data.total_cdl_open_claims) +
            parseInt(this.dashboard_data.total_matter_open_claims);
          var today = moment(new Date());
          if(this.dashboard_data.lic_license_expire_date=="" || this.dashboard_data.lic_license_expire_date==null || this.dashboard_data.lic_license_expire_date=="1969-12-31"){
            this.dashboard_data.days_of_expire_lic = 0;
            this.dashboard_data.days_of_latest_lic_exp_date=0;
            this.dashboard_data.lic_license_expire_date="";
           }else{
            var expiry_date = moment(this.dashboard_data.lic_license_expire_date);
            this.dashboard_data.days_of_expire_lic = expiry_date.diff(
              today,
              "days"
            );
            const lastRouteName = localStorage.getItem("LS_ROUTE_KEY");
            if(lastRouteName=="Login"){
              var latest_expiry_date = moment(this.dashboard_data.latest_lic_exp_date);
              if(this.dashboard_data.latest_lic_exp_date!="" && this.dashboard_data.latest_lic_exp_date!=null)
              {
                this.dashboard_data.days_of_latest_lic_exp_date = latest_expiry_date.diff(
                  today,
                  "days"
                );
              }else{
                this.dashboard_data.days_of_latest_lic_exp_date=0;
              }
              if(this.dashboard_data.latest_lic_exp_date=="" || this.dashboard_data.latest_lic_exp_date==null || this.dashboard_data.days_of_latest_lic_exp_date < 0){
                this.remindInsuranceExpiration(true);
              }
            }
          }
          
        }
      }
    );
    // this.$store.dispatch("getAttProfileData").then(() => {
    //   // console.log("attid fetched:", this.attid);
    //   this.generateDynamicLink();
    // });
  },
  async mounted() {
    const attid = this.attid || this.$store.state.profile_data.attid;
    const isSelected = await checkFeeAgreementStatus(this.$store);
    const dismissed = localStorage.getItem('feeAgreementPopupDismissed');
    this.showPopup = !isSelected && !dismissed;
    this.dynamicLink = await generateDynamicLink(attid);
    this.$store.dispatch("getDashboardData");
},
  methods: {
    dismissPopup() {
    this.showPopup = false;
    localStorage.setItem('feeAgreementPopupDismissed', 'true');
  },
    handleFeeAgreementClick() {

      // setTimeout(() => {
        // this.logoutUser();
        this.$store.dispatch("logout");

        // window.open(this.dynamicLink);
        window.location.href = this.dynamicLink;
      // }, 500);
    },
    
    // logoutUser() {
    //   this.$store.dispatch("logout");
    //   this.$router.push("/login");
    // },
    //   async generateDynamicLink() {
    //   const secret = 'MO142kXCFMpvVucyzZ8399e439DSD8Jd6rZO';
    //   const attid = this.attid;
    //   if (!attid) {
    //     console.error("attid is not available");
    //     return;
    //   }

    //   const encoder = new TextEncoder();
    //   const keyBytes = encoder.encode(secret);
    //   const dataBytes = encoder.encode(`attid=${attid}`);

    //   try {
    //     const key = await crypto.subtle.importKey(
    //       'raw',
    //       keyBytes,
    //       { name: 'HMAC', hash: { name: 'SHA-256' } },
    //       false,
    //       ['sign']
    //     );

    //     const signature = await crypto.subtle.sign('HMAC', key, dataBytes);

    //     let sig = '';
    //     const view = new DataView(signature);
    //     for (let i = 0; i < signature.byteLength; i++) {
    //       sig += ('00' + view.getUint8(i).toString(16)).slice(-2);
    //     }
    //     // const isTest = Constants.IS_TEST;
    //     // console.log("isTest",isTest);
        
    //     // if (isTest == true) {
    //     //   this.dynamicLink = `http://localhost:8080/2025feeschedule/attid=${attid}?sig=${sig}`; // For local
    //     //   // this.dynamicLink = `http://devattportal.uslegalservices.net/2025feeschedule/attid=${attid}?sig=${sig}`;  // For TEST
    //     // } else {
    //     //   this.dynamicLink = `https://attorney.uslegalservices.net/2025feeschedule/attid=${attid}?sig=${sig}`; // For PROD
    //     // }
    //     if (window.location.origin == "http://localhost:8080") {
    //       this.dynamicLink = `http://localhost:8080/2025feeschedule/attid=${attid}?sig=${sig}`;
    //     } else if (window.location.origin == "https://devattportal.uslegalservices.net") {
    //       this.dynamicLink = `http://devattportal.uslegalservices.net/2025feeschedule/attid=${attid}?sig=${sig}`;
    //     } else {
    //       this.dynamicLink = `https://attorney.uslegalservices.net/2025feeschedule/attid=${attid}?sig=${sig}`;
    //     }
    //     // console.log("this.dynamicLink",this.dynamicLink);
        
    //   } catch (error) {
    //     console.error('Error generating HMAC:', error);
    //   }
    // },
    redirect: function(path) {
      this.$router.push(path);
    },
    remindInsuranceExpiration: function(value) {
      if (value) {
        document.getElementById("insuranceModal").removeAttribute("class");
      } else {
        document.getElementById("insuranceModal").setAttribute("class", "hidden");
      }
    },
    updateAttorney: function() {
      let page = "child_comp_0";
      if (this.edit_page == "primary") {
        page = "child_comp_0";
      } else if (this.edit_page == "coverage") {
        page = "child_comp_1";
      }
      this.$refs[page].submitApplication();
      if (
        this.$refs[page].v$.form.$pending ||
        this.$refs[page].v$.form.$error
      ) {
        this.$toast.error("please fill required fields!");
        return;
      }
      if(this.form.practice_county_list.length>0){
        let check_cdl_rate=true;
        this.form.practice_county_list.forEach(element => {
          if(element.plan_class=='CDL' && (element.cdl_rate==0 || element.cdl_rate=="") && element.deleted==0){
            check_cdl_rate=false;
          }
        });
        if(!check_cdl_rate){
          this.$toast.error("Please add CDL rate for CDL Plan");
          return false;
        }
      }
      this.$store.dispatch("updateAttorneyData", {
        data: this.form,
      });
    },
    toggleCollapseShow: function(classes) {
      this.collapseShow = classes;
    },
    editDetails: function(value, profile = "") {
      $("#edit_detail div").animate({ scrollTop: 0 }, 1000);
      if (value) {
        this.edit_page = "";
        this.edit_page = profile;
        document.getElementById("edit_detail").classList.remove("hidden");
      } else {
        this.edit_page = "";
        document.getElementById("edit_detail").classList.add("hidden");
        this.$store.dispatch("getAttProfileData");
      }
    },
  },
};
</script>
